import config from 'config';
import * as storageLocale from 'i18n/storageLocale';

const getCustomHeaders = () => ({
  'Accept-Language': storageLocale.getLocale(),
  ...config.territory && { territory: config.territory }
});

export default getCustomHeaders;